import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import { formatMarkdownRichText } from '../../../utils/formatRichText';
import Image from '../../Image/Image';

const html = (value) => ({
  __html: formatMarkdownRichText(value),
});
const richTextSx = {
  '& p': { m: 0, mb: '1em' },
  '& p:last-of-type': { mb: 0 },
  '& strong': { fontWeight: 700 },
  '& ul': {
    m: 0,
    mt: '1em',
    pl: '20px',
  },
  '& li': { mb: '0.5em' },
  '& a': {
    color: '#C7CB00',
    textDecoration: 'none',
    fontWeight: 700,
  },
  '& a:hover': {
    color: '#C7CB00',
    textDecoration: 'underline',
  },
};

const SnakeGuideMobileComponent = ({ data }) => {
  if (!data) return null;

  const { title, description, cards = [] } = data;

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#F5F6F7',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ px: 2 }}>
        <ScrollFadeWrapper variant="text">
          <Typography
            component="h2"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '2.25rem',
              lineHeight: '2.75rem',
              letterSpacing: '-0.04em',
              color: '#162F3B',
              textAlign: 'center',
              mb: '16px',
            }}
          >
            {title}
          </Typography>
        </ScrollFadeWrapper>

        <ScrollFadeWrapper variant="text" delay={0.12}>
          <Typography
            component="div"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: '1.125rem',
              lineHeight: '1.625rem',
              letterSpacing: '-0.03em',
              color: '#162F3B',
              textAlign: 'center',
              mx: 'auto',
              maxWidth: '38rem',
              mb: '40px',
              whiteSpace: 'pre-line',
              ...richTextSx,
            }}
            dangerouslySetInnerHTML={html(description)}
          />
        </ScrollFadeWrapper>
      </Box>

      <Box
        sx={{ display: 'flex', flexDirection: 'column', gap: '24px', px: 2 }}
      >
        {cards.map((card, index) => {
          const icon = card.iconUrl;
          const titleText = card.title || card.heading || '';
          const body = card.body || card.description || '';

          return (
            <ScrollFadeWrapper key={index} delay={0.2 + index * 0.1}>
              <Box
                sx={{
                  backgroundColor: '#FFFFFF',
                  borderRadius: '32px',
                  boxShadow:
                    '0px 1px 2px 0px rgba(162, 172, 177, 0.18), 0px 12px 24px -4px rgba(22, 47, 59, 0.12)',
                  padding: '32px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '24px',
                }}
              >
                <Box
                  sx={{
                    width: '120px',
                    height: '120px',
                    borderRadius: '32px',
                    backgroundColor: '#C7CA00',
                    display: 'grid',
                    placeItems: 'center',
                  }}
                >
                  {icon ? (
                    <Image
                      width={120}
                      height={120}
                      src={icon}
                      alt={titleText || ''}
                      sx={{
                        width: '4rem',
                        height: '4rem',
                        objectFit: 'contain',
                        display: 'block',
                        filter:
                          'brightness(0) saturate(100%) invert(12%) sepia(24%) saturate(1118%) hue-rotate(161deg) brightness(92%) contrast(92%)',
                      }}
                    />
                  ) : null}
                </Box>

                <Typography
                  component="h3"
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 700,
                    fontSize: '1.5rem',
                    lineHeight: '1.875rem',
                    letterSpacing: '-0.03em',
                    color: '#162F3B',
                  }}
                >
                  {titleText}
                </Typography>

                <Typography
                  component="div"
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 400,
                    fontSize: '1rem',
                    lineHeight: '1.5rem',
                    letterSpacing: '-0.01em',
                    color: '#162F3B',
                    pb: '40px',
                    whiteSpace: 'pre-wrap',
                    ...richTextSx,
                  }}
                  dangerouslySetInnerHTML={html(body)}
                />
              </Box>
            </ScrollFadeWrapper>
          );
        })}
      </Box>
    </Box>
  );
};

export default SnakeGuideMobileComponent;
